/**
 * Compra por asistentes de IA (Shopify.actions) en Digital, como el standard-actions-override de Horizon 4.x (15/10/2026):
 * - deja CartLinesUpdateEvent en window para que product-form.js emita shopify:cart:lines-update;
 * - updateCart emite desde el cajón y, cuando añade el agente, se refrescan el cajón y el icono del carrito;
 * - openCart abre el cajón del tema (o /cart si no hay cajón). En /cart cada módulo lleva su enlace de compra en WHMCS.
 */
import { CartLinesUpdateEvent } from 'https://cdn.shopify.com/storefront/standard-events.js';

window.LGCartLinesUpdateEvent = CartLinesUpdateEvent;

const cartDrawer = () => document.querySelector('cart-drawer');
const cartUrl = () => (window.routes && window.routes.cart_url) || '/cart';

async function refreshCart() {
  const drawer = cartDrawer();
  const ids = drawer ? drawer.getSectionsToRender().map((s) => s.id) : ['cart-icon-bubble'];
  const sections = await (await fetch(`${window.location.pathname}?sections=${ids.join(',')}`)).json();
  if (drawer) {
    drawer.renderContents({ sections });
    return;
  }
  const bubble = document.getElementById('cart-icon-bubble');
  if (bubble && sections['cart-icon-bubble']) {
    const html = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
    const nuevo = html.getElementById('cart-icon-bubble') || html.querySelector('.shopify-section');
    if (nuevo) bubble.innerHTML = nuevo.innerHTML;
  }
  if (window.location.pathname === cartUrl()) window.location.reload();
}

// Lo que añade el tema ya refresca el cajón; lo del agente (context 'standard-action') no.
document.addEventListener(
  'shopify:cart:lines-update',
  (event) => {
    if (event.context === 'product') return;
    event.promise?.then(() => refreshCart()).catch(() => {});
  },
  true
);

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => cartDrawer() ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const drawer = cartDrawer();
      if (drawer && typeof drawer.open === 'function') {
        drawer.open();
      } else {
        window.location.href = cartUrl();
      }
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
